import * as ZapparThree from '@zappar/zappar-threejs';
import { Group, PerspectiveCamera, Scene } from 'three';
import { triggerDrawControl } from "../../..";
import { changePenUI, hideDraw, hidePenSelection, revealDrawDeleteMenu, revealDraw, revealPenSelection, setUndoButton, revealTutorial, hideTutorial, revealDrawTutorialHand, hideDrawTutorialHand } from '../../../dom';
import Renderer from '../../Renderer';
import { awaitTimer } from '../../utils';
import { LoadedGLTFs, LoadedTextures } from '../../utils/types';
import Lights from '../lights';
import { PenSelection } from './penSelection';
import { SharpieDesignEngine } from './sde/engine';
import { Snapshot } from './snapshot';
import { Params } from '../../../utils/types';
type PenType = 'brush' | 'bullet' | 'eraser' | 'none';

export default class Main {
    public engine: SharpieDesignEngine;
    private renderer: Renderer;
    private camera: PerspectiveCamera;
    private snapshot: Snapshot;
    private penSelection: PenSelection;
    private mainActive: boolean;
    private lastPen: PenType;
    private lastColor: string;
    private eraserActive: boolean
    private scene: Scene;
    private onScreen: Group;
    private lights: Lights;
    private tutorialComplete: boolean;
    private deleteMenuOpen: boolean;

    constructor(
        renderer: Renderer,
        camera: PerspectiveCamera,
        zapparCamera: ZapparThree.Camera,
        scene: Scene,
        gltfs: LoadedGLTFs,
        textures: LoadedTextures,
        onScreen: Group,
        lights: Lights,
        urlParams: Params
    ) {
        this.renderer = renderer;
        this.camera = camera;
        this.onScreen = onScreen;
        this.lights = lights

        this.engine = new SharpieDesignEngine({
            renderer: this.renderer.instance,
            camera: this.camera,
            pipeline: zapparCamera.pipeline,
        })
        this.snapshot = new Snapshot(this.renderer, textures);
        this.onScreen.add(this.snapshot.watermark)
        this.penSelection = new PenSelection(this.renderer, camera, gltfs, textures, urlParams);
        this.onScreen.add(this.penSelection.instance)
        this.mainActive = false;
        this.eraserActive = false
        this.lastPen = urlParams.penType as PenType;
        this.lastColor = urlParams.penType == 'bullet' ? '#54BBAA' : '#D42737';
        this.initMain();
        this.scene = scene;
        this.tutorialComplete = false;
        this.deleteMenuOpen = false;
    }


    public initMain = async () => {
        this.engine.setPenType('none');
        this.engine.setPenColorHex(this.lastColor);
        changePenUI(this.lastColor.replace('#', ''), this.lastPen);
        this.penSelection.setPenColourHex(this.lastColor)
    }

    public start = async () => {
        // this.engine.setPenType(this.lastPen);
        // this.engine.setVisible(true);
        // this.mainActive = true;
        // this.scene.background = null;


        // revealDrawIntro().then(() => {
        //     revealDrawTutorial()
        this.engine.addEventListener('history-change', () => {
            console.log('history change')
            setUndoButton(this.engine.canUndo())
            hideDrawTutorialHand();
        })
        //if (!this.tutorialComplete) {
        //hideDrawTutorial().then(revealDraw)
        //this.tutorialComplete = true;
        // awaitTimer(10000).then(() => {
        //     if (!this.deleteMenuOpen) {
        //         revealDrawTutorialHand();
        //     }
        // })
        // }
        // else {
        //     hideDrawTutorialHand();
        // }
        revealDraw()
        revealTutorial();
        // setUndoButton(this.engine.canUndo())
        //});
        // });
    }

    public update() {
        if (this.mainActive) {
            this.renderer.instance.autoClear = false;
            this.engine.render();
        }
    }

    public triggerDrawControl(trigger: string) {
        switch (trigger) {
            case 'undo':
                this.engine.undo();
                break;
            case 'clear':
                this.deleteMenuOpen = false;
                this.engine.clear();
                this.engine.setPenType(this.lastPen);
                break;
            case 'delete':
                this.deleteMenuOpen = true;
                revealDrawDeleteMenu();
                this.engine.setPenType('none');
                break
            case 'eraser':
                this.eraserActive = true;
                this.engine.setPenType(trigger);
                break
            case 'brush':
            case 'bullet':
                this.lastPen = trigger;
                break;
            case 'pen':
                if (this.eraserActive) {
                    this.engine.setPenType(this.lastPen);
                }
                else {
                    triggerDrawControl('penSelection')
                }
                this.eraserActive = false;
                break;
            case 'continue':
                this.engine.setVisible(true);
                this.engine.resume();
                changePenUI(this.lastColor.replace("#", ""), this.lastPen);
                this.engine.setPenType(this.lastPen);
                hidePenSelection();
                this.penSelection.hidePenSelection()
                    .then(revealDraw)
                break;
            case 'penSelection':
                this.engine.setVisible(false);
                this.engine.pause();
                this.engine.setPenType('none');
                hideDraw();
                awaitTimer(1000).then(() => {
                    revealPenSelection()
                    this.penSelection.revealPenSelection()
                })
                break;
            case 'deleteMenuNo':
                this.deleteMenuOpen = false;
                this.engine.setPenType(this.lastPen);
                break;
            case 'pause':
                this.engine.pause();
                this.engine.setPenType('none');
                break
            case 'download_back':
            case 'resume':
                this.engine.resume();
                if (this.eraserActive) {
                    this.engine.setPenType('eraser');
                }
                else {
                    this.engine.setPenType(this.lastPen);
                }
                if (this.mainActive == false) {
                    this.engine.setVisible(true);
                    this.mainActive = true;
                    this.scene.background = null;
                    revealDrawTutorialHand()
                }
                hideTutorial(this.engine.canUndo())
            default:
                if (trigger.includes('#')) {
                    this.lastColor = trigger;
                    this.engine.setPenColorHex(trigger);
                    this.penSelection.setPenColourHex(trigger)
                }
                break;
        }
        this.snapshot.triggerDrawControl(trigger)
    }
}

